import gql from 'graphql-tag'

export const GET_QUOTE = gql`
  query quotes($content: String!, $type: String!) {
    quotes(content: $content, type: $type) {
      reference
    }
  }
`
